var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteTrashBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8889 5.4H16.4444V4.3C16.4444 2.48509 14.9444 1 13.1111 1H10.8889C9.05564 1 7.55556 2.48509 7.55556 4.3V5.4H3.11111C2.49996 5.4 2 5.89522 2 6.5C2 7.10478 2.49996 7.6 3.11111 7.6H4.22222V19.7C4.22222 21.5149 5.72231 23 7.55556 23H16.4444C18.2777 23 19.7778 21.5149 19.7778 19.7V7.6H20.8889C21.5 7.6 22 7.10478 22 6.5C22 5.89522 21.5 5.4 20.8889 5.4ZM9.77778 4.3C9.77778 3.69521 10.2777 3.2 10.8889 3.2H13.1111C13.7223 3.2 14.2222 3.69521 14.2222 4.3V5.4H9.77778V4.3ZM10.8889 17.5C10.8889 18.1048 10.3889 18.6 9.77778 18.6C9.16662 18.6 8.66667 18.1048 8.66667 17.5V12C8.66667 11.3952 9.16662 10.9 9.77778 10.9C10.3889 10.9 10.8889 11.3952 10.8889 12V17.5ZM15.3333 17.5C15.3333 18.1048 14.8334 18.6 14.2222 18.6C13.6111 18.6 13.1111 18.1048 13.1111 17.5V12C13.1111 11.3952 13.6111 10.9 14.2222 10.9C14.8334 10.9 15.3333 11.3952 15.3333 12V17.5Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTrashBolt);
export default __webpack_public_path__ + "static/media/DeleteTrashBolt.161349d2fe85d178203204a123ca2507.svg";
export { ForwardRef as ReactComponent };